var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M178.309 199.218L157.458 178.542C147.397 168.564 142.366 163.575 136.592 161.751C131.515 160.147 126.058 160.206 121.016 161.92C115.284 163.868 110.362 168.965 100.519 179.158L50.5615 228.501C50.9493 231.65 51.6099 234.141 52.7352 236.349C55.132 241.053 58.9565 244.878 63.6606 247.275C69.0084 250 76.009 250 90.0103 250H210.01C224.012 250 231.012 250 236.36 247.275C241.064 244.878 244.889 241.053 247.285 236.349C250.01 231.002 250.01 224.001 250.01 210V206.168L239.553 195.642C229.712 185.423 224.791 180.313 219.055 178.358C214.011 176.638 208.549 176.575 203.466 178.179C197.687 180.002 192.65 184.997 182.576 194.987L178.309 199.218Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_d_5894_8387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 37.5L231.25 68.75M231.25 68.75L262.5 100M231.25 68.75L262.5 37.5M231.25 68.75L200 100M178.298 199.22L157.448 178.543C147.386 168.566 142.355 163.577 136.582 161.753C131.505 160.149 126.048 160.208 121.006 161.921C115.273 163.87 110.352 168.966 100.509 179.159L50.5512 228.503M178.298 199.22L182.566 194.988C192.64 184.998 197.676 180.003 203.456 178.18C208.538 176.577 214 176.64 219.045 178.36C224.78 180.315 229.701 185.425 239.543 195.644L250 206.169M178.298 199.22L228.437 249.458M228.437 249.458C223.97 250.001 218.179 250.001 210 250.001H90C75.9987 250.001 68.998 250.001 63.6502 247.276C58.9462 244.88 55.1217 241.055 52.7248 236.351C51.5995 234.143 50.939 231.652 50.5512 228.503M228.437 249.458C231.617 249.071 234.126 248.41 236.35 247.276C241.054 244.88 244.878 241.055 247.275 236.351C250 231.003 250 224.003 250 210.001V206.169M150 49.9939L90 50.0013C75.9987 50.0013 68.998 50.0013 63.6502 52.7262C58.9462 55.123 55.1217 58.9475 52.7248 63.6516C50 68.9994 50 76 50 90.0013V210.001C50 218.22 50 224.027 50.5512 228.503M250 149.994V206.169",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5894_8387",
    x: 38.5,
    y: 30,
    width: 235.5,
    height: 235.501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5894_8387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5894_8387",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIcon);
export default __webpack_public_path__ + "static/media/noIcon.8bb19cbcdd60853290117734ea2913e8.svg";
export { ForwardRef as ReactComponent };